module.exports = __webpack_public_path__ + "static/img/3.483d699.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/zh/3.png
// module id = c5pg
// module chunks = 0